export enum Routes {
  HOME = '/',
  FULL_CYCLE_DEVELOPMENT = '/services/full-cycle-development',
  SOFTWARE_TEAMS_OFFLOADING = '/services/software-teams-offloading',
  MOST_VIABLE_PRODUCT_DEVELOPMENT = '/services/most-viable-product-development',
  TECHNICAL_DEBT_RESOLUTION = '/services/technical-debt-resolution',
  ARTIFICIAL_INTELLIGENCE_SYSTEMS = '/services/artificial-intelligence-systems',
  // AI_AGENTS = '/services/ai-agents',
  // AI_WORKFLOW_AUTOMATION = '/services/ai-workflow-automation',
  AI_KNOWLEDGE_MANAGEMENT = '/services/ai-knowledge-management',

  KNOWLEDGE_MANAGEMENT = '/solutions/knowledge-management',
  AI_AGENTS = '/solutions/ai-agents',
  AUTOMATION = '/solutions/automation',
  FIELD_SERVICE_MAINTENANCE = '/solutions/field-service-maintenance',
  // COMPLIANCE = '/solutions/compliance',

  // Legacy slugs, redirected to the new capability/solution pages
  LEGACY_CRITICAL_INFRASTRUCTURE = '/solutions/critical-infrastructure',
  LEGACY_INDUSTRIAL_OPERATIONS = '/solutions/industrial',
  LEGACY_ENTERPRISE_AI = '/solutions/enterprise',

  OUR_METHOD = '/method',
  CAREER = '/career',
  TERMS_AND_CONDITIONS = '/terms',
  PRIVACY_POLICY = '/privacy',
  SUSTAINABILITY = '/sustainability',
  BLOG = '/blog',
  INDUSTRIES = '/industries',
  PROJECTS = '/projects',
  MEET_WITH_US = '/meet-with-us',
  CONTACT = '/contact',
}

// Hidden, standalone product landing pages.
// These live in their own zone (src/business/product-pages) with their own
// layout. They are not linked from the site, are excluded from the sitemap,
// and are disallowed in robots.txt: only reachable via direct link / QR code.
// See HIDDEN_ROUTES below, which drives robots.txt + sitemap generation.
export const HiddenProductRoutes = {
  TALENT_MATCHER: '/talent-match',
  PAY_TRANSPARENCY: '/pay-transparency',
} as const;

export const HIDDEN_ROUTES: string[] = Object.values(HiddenProductRoutes);

// Memorable shortlinks for print, QR codes, and conversations.
// These are NOT pages: they resolve to a server-side 301 in netlify.toml and
// must never be added to the router (a prerendered file at the same path would
// shadow the redirect on Netlify) nor to the sitemap.
export const Shortlinks: Record<string, string> = {
  '/km': Routes.KNOWLEDGE_MANAGEMENT,
};

export enum ProjectRoutes {
  CAPMO_AI = '/capmo-ai',
  INDUSTRIAL_TECHNICIANS = '/industrial-technicians',
  // AUDIT_FIRM = '/audit-firm',
  // PUBLISHING_PLATFORM = '/publishing-platform',
  COMMUNICATION_PLATFORM = '/communication-platform',
  // PAY_AT_TABLE = '/pay-at-table',
  VEGETOIL = '/vegetoil',
  // HOME_AUTOMATION = '/home-automation',
  // PART_TIMERZ = '/part-timerz',
  // BOHO_BABY_MARKET = '/boho-baby-market',
  MEDTECH_NOTIFICATION_SYSTEM = '/medtech-notification-system',
  MOBILISIGHTS = '/mobilisights',
  RESEARCH_AUTOMATION_PLATFORM = '/research-automation-platform',
  STUDENT_ORIENTATION = '/student-orientation',
  UNIVERSUM_PRESALES = '/universum-pre-sales',
  ASSET_MANAGEMENT_PLATFORM = '/asset-management-platform',
  CUSTOMER_PORTAL = '/customer-portal',
  // BOOK_PUBLISHING_PLATFORM = '/book-publishing-platform',
}

export enum JobRoutes {
  FULL_STACK_DEVELOPER = '/full-stack-developer',
  FRONTEND_DEVELOPER = '/frontend-developer',
  UX_UI_DESIGNER = '/ux-ui-designer',
  TECHNICAL_CONTENT_WRITER = '/technical-content-writer',
}

export enum IndustryRoutes {
  HEALTHCARE = '/industries/healthcare',
  AUTOMOTIVE = '/industries/automotive',
  CONSTRUCTION = '/industries/construction',
  EDUCATION = '/industries/education',
  GOVERNMENT = '/industries/government',
  AEROSPACE = '/industries/aerospace',
  MANUFACTURING = '/industries/manufacturing',
  ROBOTICS = '/industries/robotics',
  ENERGY = '/industries/energy',
  FINANCE = '/industries/finance',
  EVENTS = '/industries/events',
}

export enum BlogRoutes {
  WHY_GENERIC_AI_WONT_POWER_THE_NEXT_INDUSTRIAL_REVOLUTION = '/why_generic_ai_wont_power_the_next_industrial_revolution',
  IS_THERE_A_WAY_PAST_KNOWLEDGE_FRICTION_IN_AUTOMOTIVE_OPERATIONS = '/is_there_a_way_past_knowledge_friction_in_automotive_operations',
  AI_IN_AEROSPACE_BUILDING_SOVEREIGN_KNOWLEDGE_SYSTEMS = '/ai_in_aerospace_building_sovereign_knowledge_systems',
  CAPMO_AI = ProjectRoutes.CAPMO_AI,
  INDUSTRIAL_TECHNICIANS = ProjectRoutes.INDUSTRIAL_TECHNICIANS,
}
